import qs from 'qs';
import AppRouteInfo from "../routers/AppRouter/info";
import {matchPath} from "react-router";

export function getInitData() {
    const initData = qs.parse(window.location.search.slice(1));
    if (initData.toggle) {
        initData.toggle.free_shipping =
            initData.toggle.free_shipping === 'true' ? true : undefined;
    }
    return initData;
}
export function setUrl(searchState) {
    const search = searchState
        ? `${window.location.pathname}?${qs.stringify(searchState)}`
        : '';
    window.history.pushState(searchState, null, search);
}

function getMatch(to, allRoutes) {
    for (const route of allRoutes) {
        const match = matchPath(to, {...route, exact: true});
        if (match)
            return match.path;
    }
    return null;
}

export function getCurrent() {
    if (!window || !window.location.pathname)
        return [];

    let {pathname} = window.location;
    if (pathname === '/')
        return [];

    // Check in appRoutes for "sidebarParentId"
    const match = getMatch(pathname, AppRouteInfo);
    const routeData = AppRouteInfo.find(route => route.path === match);

    if (routeData && routeData.sidebarParentId) {
        const parentRouteData = AppRouteInfo.find(route => route.id === routeData.sidebarParentId);
        if (parentRouteData)
            pathname = parentRouteData.path;
    }

    const pathParts = pathname.split('/');
    if (pathParts.length === 2) {
        const current = `/${pathParts[1]}`;
        return [current];
    }
    if (pathParts.length > 2) {
        const output = [];
        pathParts.forEach((part, idx) => {
            if (idx <= 0) {
                // do nothing
            }
            else if (output.length === 0) {
                output.push(`/${part}`);
            }
            else {
                output.push(`${output[output.length - 1]}/${part}`);
            }
        });
        return output;
    }
    return null;
}

export function getOpenKeys() {
    if (!window || !window.location.pathname)
        return [];

    const {pathname} = window.location;
    if (pathname === '/')
        return [];

    const pathParts = pathname.split('/');
    const openKey = `/${pathParts[1]}`;
    return [openKey];
}

export function getDefaultPath() {
    const current = getCurrent();
    const openKeys = getOpenKeys();

    return [current, openKeys];
}

export function getRootUrl(subdomain) {
    const urlProtocol = process.env.REACT_APP_URL_PROTOCOL;
    const urlDomain = process.env.REACT_APP_URL_DOMAIN;
    const urlPort = process.env.REACT_APP_URL_PORT;
    const urlMode = process.env.REACT_APP_URL_MODE;

    if (urlMode === "single")
        return '';
    return `${urlProtocol}://${subdomain}.${urlDomain}${urlPort !== '80' ? `:${urlPort}` : ''}`;
}
